import { useIntl } from "react-intl";

import BannerAlert, { BannerProps } from "@/components/wpl/banner-alert/src";
import { useLocalizedHref } from "@/libraries/web-framework";

export const JSWFeaturesPageBanner = () => {
    const intl = useIntl();

    const aiBannerMessages: BannerProps = {
        identifier:
            "JiraSoftwareFeaturesPageTemplate.atlassian-intelligence_exp",
        text: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageTemplate.banner-alert.atlassian-intelligence_exp",
            defaultMessage:
                "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageTemplate.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };

    return <BannerAlert {...aiBannerMessages} />;
};
